import React, {useEffect, useState} from 'react';
import Page from '../../Components/Page';
import {columns} from './ContinuityTable';
import _ from 'lodash';
import DynamicColumns from './DynamicColumns';
import moment from 'moment';
import {sortAscendingWithNullsFirst} from '../../../utils/sorting';
import Checkbox from "../../Components/Checkbox";
import {makeApolloClientCall} from "../../../Api/makeApolloApiCall";
import {LoadingWrapper} from "../../Components/LoadingWrapper";

export function getWhatWillFillQuery(startWeekId, fillIncludePlu) {
    const today = moment(Date.now()).format('yyyy-MM-DD');
    return `
    query{
        data:storeSalesDateValidation(
                skipFillChecks: false, 
                startWeekId: ${startWeekId}, 
                fillEndDate: "${today}", 
                includePlu: ${fillIncludePlu}
            ){
            retailerId
            dates:datesToFill { weekEndDate }
            storeId
        }
    }
`

}

export function getDynamicColumns({data}) {
    const allDates = [];
    data.forEach(store => {
        store.dates.forEach(date => {
            allDates.push(date);
        });
    });
    const uniqueSortedDates = _.uniq(allDates).sort().reverse();

    return uniqueSortedDates.map(date => {
        return {
            id: date,
            header: date,
            enableColumnFilter: false,
            sortingFn: sortAscendingWithNullsFirst,
            accessorFn: (retailer) => {
                const possiblyFoundDate = retailer.dates.find(rowDate => rowDate === date);
                return possiblyFoundDate ? 'X' : '';
            }
        }
    });
}

export function reduceByStoreId({data}) {
    const startDate = moment(Date.now()).add(-5, 'weeks').format('yyyy-MM-DD');
    const getDatesFromCurrentStore = currentValue => currentValue.dates.map(date => date.weekEndDate).filter(date => date >= startDate);
    return {
        data: data.reduce((accumulator, currentValue) => {
            let possiblyFoundRetailerAndStore = accumulator.find(retailerAndStore =>
                retailerAndStore.retailerId === currentValue.retailerId &&
                retailerAndStore.storeId === currentValue.storeId);

            if (possiblyFoundRetailerAndStore) {
                possiblyFoundRetailerAndStore.dates = possiblyFoundRetailerAndStore.dates
                    .concat(getDatesFromCurrentStore(currentValue));
            } else {
                const datesFromCurrentStore = getDatesFromCurrentStore(currentValue);
                !_.isEmpty(datesFromCurrentStore) && accumulator.push({
                    retailerId: currentValue.retailerId,
                    storeId: currentValue.storeId,
                    dates: datesFromCurrentStore
                })
            }
            return accumulator;
        }, [])
    }
}

const WhatWillFillPage = () => {
    const [fillIncludePlu, setFillIncludePlu] = useState(true);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(undefined);
    const [error, setError] = useState(undefined);


    useEffect(() => {
        setLoading(true);
        setData(undefined);
        setError(undefined);

        const yearAgo = moment(Date.now()).add(-365, 'days').format('yyyy-MM-DD');
        const convertDateToPeriodQuery = `query { convertDateToPeriod(date:"${yearAgo}"){ weekId } }`;

        makeApolloClientCall(convertDateToPeriodQuery)
            .then((result) => {
                return result.convertDateToPeriod[0].weekId;
            })
            .then((startingWeekId) => {
                makeApolloClientCall(getWhatWillFillQuery(startingWeekId, fillIncludePlu))
                    .then((result) => reduceByStoreId(result))
                    .then((processedData) => {
                        setData(processedData)
                        setLoading(false)
                    })
                    .catch(() => {
                        setError('storeSalesDateValidation Query Failed, Please Try Again');
                        setLoading(false);
                    })
            })
            .catch(() => setLoading(false));

    }, [fillIncludePlu]);

    return (<Page name="What Will Fill" beta={true}>
        <div className={'what-will-fill-selection-group'}>
            <div className={'column'}>
                <div className={'horizontal-control-block-element-left'}>
                    <Checkbox checked={fillIncludePlu}
                              labelText='Include Plu'
                              onChange={() => setFillIncludePlu(!fillIncludePlu)}
                    />
                </div>
            </div>
        </div>
        <div className={'what-will-fill-table-wrapper'}>
            <LoadingWrapper loading={loading}>
                {data && <DynamicColumns columns={columns} data={data} dynamicColumnsFunc={getDynamicColumns}/>}
                {error && <div className={'error-message-wrapper'} data-testid={'error-message'}>{error}</div>}
            </LoadingWrapper>
        </div>
    </Page>);
};

export default WhatWillFillPage;